import React, { useRef, useState } from 'react';
import { Input } from '../Form';

export function DateOfBirth({ ages, label, data, errorMessage, handleChange }) {
  const [day, setDay] = useState(data.dateOfBirthDay);
  const [month, setMonth] = useState(data.dateOfBirthMonth);
  const [year, setYear] = useState(data.dateOfBirthYear || ages[0]);

  const dayRef = useRef(null);
  const onDayChange = (e) => {
    const value = e.target.value;
    setDay(value);
    updateDate(value, month, year);
  };

  const monthRef = useRef(null);
  const onMonthChange = (e) => {
    const value = e.target.value;
    setMonth(value);
    updateDate(day, value, year);
  };

  const yearRef = useRef(null);
  const onYearChange = (e) => {
    const value = e.target.value;
    setYear(value);
    updateDate(day, month, value);
  };

  function updateDate(day, month, year) {
    if (day && month && year) {
      handleChange({
        target: {
          value: `${day}/${month}/${year}`,
        },
      });
    } else {
      handleChange({
        target: {
          value: null,
        },
      });
    }
  }

  return (
    <Input label={label} name="dateOfBirth" errorMessage={errorMessage}>
      <div className="grid grid-cols-10 gap-2">
        <div className="col-span-3">
          <input
            type="text"
            id={'dob-day'}
            name={'dob-day'}
            ref={dayRef}
            maxLength={2}
            value={data.dateOfBirthDay}
            onKeyDown={(e) => {
              if (
                !/[0-9]|Backspace|Tab|Enter|Delete|ArrowLeft|ArrowRight/.test(
                  e.key
                )
              ) {
                e.preventDefault();
              }
            }}
            onChange={onDayChange}
            className="mt-1 focus:ring-purple-500 focus:border-purple-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>
        <div className="col-span-3">
          <input
            type="text"
            id={'dob-month'}
            name={'dob-month'}
            maxLength={2}
            onKeyDown={(e) => {
              if (
                !/[0-9]|Backspace|Tab|Enter|Delete|ArrowLeft|ArrowRight/.test(
                  e.key
                )
              ) {
                e.preventDefault();
              }
            }}
            ref={monthRef}
            value={data.dateOfBirthMonth}
            onChange={onMonthChange}
            className="mt-1 focus:ring-purple-500 focus:border-purple-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          />
        </div>
        <div className="col-span-4">
          <select
            rows={4}
            id={'dob-year'}
            name={'dob-year'}
            ref={yearRef}
            value={data.dateOfBirthYear}
            onChange={onYearChange}
            className="mt-1 focus:ring-purple-500 focus:border-purple-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          >
            {ages.map((age) => (
              <option key={`year-${age}`} value={age}>
                {age}
              </option>
            ))}
          </select>
        </div>
      </div>
    </Input>
  );
}
